module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_2.9aacc902.png";